import React from 'react';
import PropTypes from 'prop-types';
import { ListItem, ListItemIcon, ListItemText } from '@material-ui/core';
import { Link } from 'react-router-dom';
import { colors } from 'kangarootime-ui';
import BadgeCount from './BadgeCount';

const DrawerItem = ({ route, icon, label, badgeCount, isActiveRoute }) => (
  <ListItem
    button
    component={Link}
    to={route}
    style={{ height: 48, padding: 0, borderLeft: isActiveRoute && `2.5px solid ${colors.brand_2}`, backgroundColor: isActiveRoute && '#684E79' }}
  >
    <ListItemIcon style={{ marginLeft: 16 }}>
      {icon}
    </ListItemIcon>
    <ListItemText
      primary={label}
      style={{ color: colors.white }}
      primaryTypographyProps={{ style: { fontFamily: 'proxima-soft, sans-serif' } }}
    />
    { badgeCount && badgeCount > 0
      ? <BadgeCount>{badgeCount}</BadgeCount>
      : null
    }
  </ListItem>
);

DrawerItem.propTypes = {
  route: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  icon: PropTypes.object.isRequired,
  badgeCount: PropTypes.number,
  isActiveRoute: PropTypes.bool
};

export default DrawerItem;
